import React, { Component } from 'react';
import { Alert, Button, Col, Divider, Input, Modal, Row, Tabs } from 'antd';
import FolderTree from '../layout/FolderTree';
import {
  folderCreate,
  folderDelete,
  folderEdit,
  folderGet,
  folderGetParentByUser,
} from '../requests/Folder';
import { AppContext } from '../libs/ContextLibs';

const { TabPane } = Tabs;
const InputGroup = Input.Group;

export default class Folder extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      errorMessage: '',
      selectedFolder: {},
      selectedFolderID: '',
      deleteFolderName: '',
      parentFolder: {},
      parentFolderID: '',
      newFolderName: '',
      editFolderName: '',
      errorResponse: false,
      folderSaved: false,
      updateChildTree: false,
      isRefresh: false,
      disabledSave: false,
      tree: [],
      isDisabledDelete: false,
      showDeleteModal: false,
    };
    this.handleFolderChange = this.handleFolderChange.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
    this.saveNewFolder = this.saveNewFolder.bind(this);
    this.onErrorAlertDismiss = this.onErrorAlertDismiss.bind(this);
    this.onAlertDismiss = this.onAlertDismiss.bind(this);
    this.updateChildTree = this.updateChildTree.bind(this);
    this.editFolder = this.editFolder.bind(this);
    this.deleteFolder = this.deleteFolder.bind(this);
  }

  errorMessages = {
    folderLevelError: 'Cannot create a folder at the 4th hierarchy level!',
    somethingWentWrong: 'Something went wrong!',
  };

  onErrorAlertDismiss() {
    this.setState({ errorResponse: false });
  }

  onAlertDismiss() {
    this.setState({ folderSaved: false });
  }

  updateChildTree(val) {
    this.setState({ isRefresh: val });
  }

  async saveNewFolder() {
    let { parentFolder, newFolderName } = this.state;
    let newFolderlevel = Number(parentFolder.level) + 1;
    let data = {
      user_id: this.context.user.username,
      name: newFolderName,
      folder_type: 'Dashboard',
      level: newFolderlevel,
      charts: [],
    };
    if (newFolderName.trim() !== '') {
      if (parentFolder && parentFolder._id) {
        folderGet(
          parentFolder._id,
          (response) => {
            parentFolder = response;
            data.level = Number(parentFolder.level) + 1;
            if (data.level < 4) {
              folderCreate(
                data,
                (r) => {
                  parentFolder.children.push(r._id);
                  folderEdit(
                    parentFolder,
                    (r2) => {
                      this.setState({
                        parentFolder: r2,
                        folderSaved: true,
                        isRefresh: true,
                        newFolderName: '',
                      });
                    },
                    (error) => {
                      this.setState({ errorResponse: true });
                      console.log(error);
                    },
                  );
                },
                (error) => {
                  this.setState({ errorResponse: true });
                  console.log(error);
                },
              );
            } else {
              this.setState({
                errorResponse: true,
                errorMessage: this.errorMessages.folderLevelError,
              });
            }
          },
          (error) => {
            this.setState({ errorResponse: true });
            console.log(error);
          },
        );
      } else {
        folderCreate(
          data,
          (r) => {
            parentFolder.children.push(r._id);
            folderEdit(
              parentFolder,
              (r2) => {
                this.setState({
                  parentFolder: r2,
                  folderSaved: true,
                  isRefresh: true,
                  newFolderName: '',
                });
              },
              (error) => {
                this.setState({ errorResponse: true });
                console.log(error);
              },
            );
          },
          (error) => {
            this.setState({ errorResponse: true });
            console.log(error);
          },
        );
      }
    } else {
      this.setState({ errorResponse: true });
    }
  }

  async editFolder() {
    folderGet(
      this.state.selectedFolderID,
      (response) => {
        this.setState({
          selectedFolder: response,
          editFolderName: response.name,
        });
      },
      (error) => {
        this.setState({ errorResponse: true });
        console.log(error);
      },
    );
  }

  updateFolder = () => {
    if (this.state.selectedFolder.level === 0) {
      this.setState({
        errorResponse: true,
        errorMessage: 'Cannot update the primary folder!',
      });
    } else {
      folderEdit(
        { ...this.state.selectedFolder, name: this.state.editFolderName },
        (data) => {
          this.setState({ isRefresh: true });
        },
      );
    }
  };

  handleEdit = (event) => {
    this.setState({
      editFolderName: event.target.value,
    });
  };

  updateRefresh = (val) => {
    this.setState({ isRefresh: val });
  };

  async deleteFolder() {
    folderGet(
      this.state.selectedFolderID,
      (response) => {
        this.setState({
          selectedFolder: response,
          deleteFolderName: response.name,
          isDisabledDelete: response.children.length > 0,
        });
      },
      (error) => {
        this.setState({ errorResponse: true });
        console.log(error);
      },
    );
  }

  deleteUpdate = () => {
    this.setState({ showDeleteModal: true });
  };

  handleDeleteCancel = () => {
    this.setState({ showDeleteModal: false });
  };

  handleDeleteOk = () => {
    this.setState({ showDeleteModal: false });
    if (this.state.selectedFolder.level === 0) {
      this.setState({
        errorResponse: true,
        errorMessage: "Deleting 'Dashboards' folder is not permitted.",
      });
    } else {
      folderDelete({ ...this.state.selectedFolder }, (data) => {
        const folderPath = Array.isArray(this.state.tree)
          ? this.findParent(this.state.tree, this.state.selectedFolder._id)
          : [];
        if (folderPath.length > 1) {
          folderGet(
            folderPath[folderPath.length - 2],
            (response) => {
              let parentFolder = response;
              const chartIds = this.state.selectedFolder.charts.map(
                (a) => a._id,
              );
              parentFolder.charts = parentFolder.charts.concat(chartIds);
              folderEdit(
                parentFolder,
                (response3) => {
                  this.setState({ isRefresh: true });
                },
                (error) => {
                  this.setState({ errorResponse: true });
                },
              );
            },
            (error) => {
              this.setState({ errorResponse: true });
            },
          );
        }
        this.setState({
          isRefresh: true,
          selectedFolder: {},
          selectedFolderID: '',
        });
      });
    }
  };

  handleSelectFolderEdit = (node) => {
    this.setState({
      selectedFolder: node,
      editFolderName: node.name,
      selectedFolderID: node._id,
    });
  };

  handleSelectFolderChange = (node, tree) => {
    this.setState({
      selectedFolder: node,
      tree: tree,
      selectedFolderID: node._id,
      isDisabledDelete: node.level === 0,
    });
  };

  handleInputChange(event) {
    this.setState({
      newFolderName: event.target.value,
      disabledSave: event.target.value.trim() === '' ? true : false,
    });
  }

  deleteRefresh = (val) => {
    this.setState({ isRefresh: val });
  };

  findParent(array, name) {
    var result;
    array.some((o) => {
      var temp;
      if (o._id === name) {
        return (result = [name]);
      }
      temp = this.findParent(o.children || [], name);
      if (temp) {
        return (result = [o._id, ...temp]);
      }
      return false;
    });
    return result;
  }

  handleFolderChange(node) {
    this.setState({ parentFolder: node });
  }

  async componentDidMount() {
    this.setState({ userName: this.context.user.username });
    folderGetParentByUser(this.context.user.username, (response) => {
      this.setState({
        parentFolder: response,
        parentFolderID: response._id,
      });
      this.setState({
        selectedFolder: response,
        selectedFolderID: response._id,
      });
    });
  }

  render() {
    return (
      <>
        <Tabs defaultActiveKey='1' tabPosition='left' style={{ height: 400 }}>
          <TabPane tab='Create' key='1' onClick={this.updateTab}>
            <div style={{ background: '#fff', padding: 10, minHeight: 280 }}>
              <Row>
                <Col span={15}>
                  <strong>Create New Folder</strong>
                </Col>
              </Row>

              <Row>
                <Col span={15}>
                  {this.state.folderSaved ? (
                    <Alert
                      style={{ marginBottom: 10 }}
                      showIcon
                      closable
                      type='info'
                      message='Folder saved successfully.'
                      onClose={this.onAlertDismiss}
                    />
                  ) : null}
                  {this.state.errorResponse ? (
                    <Alert
                      style={{ marginBottom: 10 }}
                      showIcon
                      closable
                      type='error'
                      message={this.state.errorMessage}
                      onClose={this.onErrorAlertDismiss}
                    />
                  ) : null}
                </Col>
              </Row>

              <Row className='mt-sm-3'>
                <Col span={15}>
                  <InputGroup compact>
                    <Input
                      autoFocus
                      style={{ width: '80%' }}
                      placeholder='Enter Folder Name'
                      value={this.state.newFolderName}
                      className='col-6'
                      id='folderName'
                      onChange={this.handleInputChange}
                      onPressEnter={this.saveNewFolder}
                    />
                    <Button
                      type='primary'
                      onClick={this.saveNewFolder}
                      disabled={
                        this.state.newFolderName.trim() === '' ? true : false
                      }
                    >
                      Save
                    </Button>
                  </InputGroup>
                </Col>
              </Row>

              <div className='mt-sm-3'>
                Pick a folder to save the new folder under. Leave blank to
                create it under Dashboards folder.
              </div>
              <FolderTree
                selectedFolderID={this.state.parentFolderID}
                onChange={this.handleFolderChange}
                userName={
                  this.context.isUserNameOverride &&
                  this.context.userNameOverride
                    ? this.context.userNameOverride
                    : this.context.user.username
                }
                isRefresh={this.state.isRefresh}
                updateAction={this.updateChildTree}
              />
              <Divider />
            </div>
          </TabPane>

          <TabPane tab='Edit' key='2'>
            <div style={{ background: '#fff', padding: 10, minHeight: 280 }}>
              <Row>
                <Col span={15}>
                  <strong>Edit Folder</strong>
                </Col>
              </Row>
              <Row>
                <Col span={15}>
                  {this.state.folderSaved ? (
                    <Alert
                      style={{ marginBottom: 10 }}
                      showIcon
                      closable
                      type='info'
                      message='Folder Updated successfully.'
                      onClose={this.onAlertDismiss}
                    />
                  ) : null}
                  {this.state.errorResponse ? (
                    <Alert
                      style={{ marginBottom: 10 }}
                      showIcon
                      closable
                      type='error'
                      message={this.state.errorMessage}
                      onClose={this.onErrorAlertDismiss}
                    />
                  ) : null}
                </Col>
              </Row>
              <Row className='mt-sm-3'>
                <Col span={15}>
                  <InputGroup compact>
                    <Input
                      autoFocus
                      style={{ width: '80%' }}
                      placeholder='Edit Folder Name'
                      value={this.state.editFolderName}
                      className='col-6'
                      id='folderName'
                      onChange={this.handleEdit}
                      onPressEnter={this.updateFolder}
                    />
                    <Button type='primary' onClick={this.updateFolder}>
                      Update
                    </Button>
                  </InputGroup>
                </Col>
              </Row>
              <div className='mt-sm-3'>Pick a folder to Edit</div>
              <FolderTree
                selectedFolderID={this.state.selectedFolderID}
                onChange={this.handleSelectFolderEdit}
                userName={
                  this.context.isUserNameOverride &&
                  this.context.userNameOverride
                    ? this.context.userNameOverride
                    : this.context.user.username
                }
                isRefresh={this.state.isRefresh}
                updateAction={this.updateRefresh}
              />
              <Divider />
            </div>
          </TabPane>

          <TabPane tab='Delete' key='3'>
            <div style={{ background: '#fff', padding: 10, minHeight: 280 }}>
              <Row>
                <Col span={15}>
                  <strong>Pick a Folder to Delete</strong>
                </Col>
              </Row>

              <Row>
                <Col span={15}>
                  {this.state.folderSaved ? (
                    <Alert
                      style={{ marginBottom: 10 }}
                      showIcon
                      closable
                      type='info'
                      message='Folder Updated successfully.'
                      onClose={this.onAlertDismiss}
                    />
                  ) : null}
                  {this.state.errorResponse ? (
                    <Alert
                      style={{ marginBottom: 10 }}
                      showIcon
                      closable
                      type='error'
                      message={this.state.errorMessage}
                      onClose={this.onErrorAlertDismiss}
                    />
                  ) : null}
                </Col>
              </Row>
              <FolderTree
                selectedFolderID={this.state.selectedFolderID}
                onChange={this.handleSelectFolderChange}
                userName={
                  this.context.isUserNameOverride &&
                  this.context.userNameOverride
                    ? this.context.userNameOverride
                    : this.context.user.username
                }
                isRefresh={this.state.isRefresh}
                updateAction={this.deleteRefresh}
              />

              <Row className='mt-sm-3'>
                <Col span={15}>
                  <Button
                    type='primary'
                    danger
                    onClick={this.deleteUpdate}
                    disabled={
                      !this.state.selectedFolder._id ||
                      this.state.isDisabledDelete ||
                      (this.state.selectedFolder.children &&
                        this.state.selectedFolder.children.length > 0)
                    }
                  >
                    Delete
                  </Button>
                </Col>
              </Row>
              <Divider />
            </div>
          </TabPane>
        </Tabs>
        <Modal
          title='Delete folder?'
          open={this.state.showDeleteModal}
          onOk={this.handleDeleteOk}
          onCancel={this.handleDeleteCancel}
          okType='primary'
          okButtonProps={{ danger: true }}
          okText='Delete'
        >
          <p>
            Deleting this folder will move its dashboards to its parent folder.
          </p>
        </Modal>
      </>
    );
  }
}
